import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { formilyCore } from '@alife/cn-ui';
import { getDynamicFromSchema } from 'src/services';
import { getFormScheme } from 'src/utils/worker-order';
export function useGetDynamicSchema() {
    return useCallback(async (params) => {
        try {
            let formConfig = await getDynamicFromSchema(params);
            const { schema, hasMerchantCnMemberId } = await getFormScheme(formConfig);
            return {
                formConfig,
                schema,
                hasMerchantCnMemberId,
            };
        }
        catch (e) {
            console.error(e, 'getDynamicFromSchema');
            return {
                formConfig: undefined,
                schema: undefined,
                hasMerchantCnMemberId: false
            };
        }
    }, []);
}
export function useFormSchema({ bizTypeId, ...rest }) {
    const [scheme, setScheme] = useState({});
    const [formConfig, setFormConfig] = useState({});
    const [hasMerchantCnMemberId, setHasMerchantCnMemberId] = useState();
    const getDynamicSchema = useGetDynamicSchema();
    useEffect(() => {
        if (!bizTypeId) {
            setScheme({});
            return;
        }
        const main = async () => {
            const data = await getDynamicSchema({ bizTypeId, ...rest });
            setFormConfig(data.formConfig);
            setHasMerchantCnMemberId(data.hasMerchantCnMemberId);
            setScheme({
                type: 'object',
                properties: {
                    formGrid: {
                        type: 'void',
                        'x-component': 'CnFormGrid',
                        'x-component-props': {
                            cols: 1,
                        },
                        properties: data.schema
                    }
                }
            });
        };
        main();
    }, [bizTypeId]);
    return { scheme, formConfig, hasMerchantCnMemberId };
}
export function useWorkOrderForm(params) {
    const { scheme, formConfig, hasMerchantCnMemberId } = useFormSchema(params);
    const formRef = useRef();
    const form = useMemo(() => {
        return formilyCore.createForm({
            initialValues: {
                ...formRef.current?.values,
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scheme]);
    formRef.current = form;
    if (!scheme || !Object.keys(scheme).length) {
        return { from: null, scheme: null, hasMerchantCnMemberId: null };
    }
    return { form, scheme, formConfig, hasMerchantCnMemberId };
}
